// @flow
import api from 'tim-api';
import {
  tokenSigtimRecarga as tokenSigTimEndpoint,
  tokenVisit as tokenVisitEndpoint,
  tokenSigtimRastreabilidadeRecarga,
  tokenSigtimRastreabilidadeChip,
  tokenSigtimQualidade,
  tokenSigtimCapilaridade,
  tokenSigtimInvasoesPenalidades,
  tokenSigtimPenetracaoChip,
  tokenSigtimMeuPainel,
  tokenSigtimPaliativo,
  tokenSigtimDrillDownChip,
  tokenSigtimRastreabilidadeApis,
  tokenVisitCheckList,
  tokenPlanosAcao,
  tokenPainelGerencial,
  tokenHDCIntegracao,
  tokenOperacaoAMSTIM,
  tokenAccessRequests,
  tokenLastAccessUser as tokenLastAccessUser,
  tokenAccessControlDepartmentalSystems,
  tokenHomeBroker,
  tokenSigtimImportManagement,
  tokenTimClosing,
  tokenCapillarity,
  tokenFinancial
} from 'endPoints';

export const state: Object = {
  token: '',
  reportId: ''
};

export const getters = {
  token: (state: Object) => state.token,
  reportId: (state: Object) => state.reportId
};

export const mutations = {
  SET_TOKEN(state: Object, token: String) {
    state.token = token;
  },
  SET_REPORTID(state: Object, reportId: String) {
    state.reportId = reportId;
  }
};

export const actions = {
  fetchSigTimToken({ commit }: Action) {
    return api.get(tokenSigTimEndpoint).then(({ data }) => {
      commit('SET_TOKEN', data.data.token);
      commit('SET_REPORTID', data.data.reportId);
    });
  },

  fetchSigTimRastreabilidadeRecargaToken({ commit }: Action) {
    return api.get(tokenSigtimRastreabilidadeRecarga).then(({ data }) => {
      commit('SET_TOKEN', data.data.token);
      commit('SET_REPORTID', data.data.reportId);
    });
  },
  fetchSigTimRastreabilidadeChipToken({ commit }: Action) {
    return api.get(tokenSigtimRastreabilidadeChip).then(({ data }) => {
      commit('SET_TOKEN', data.data.token);
      commit('SET_REPORTID', data.data.reportId);
    });
  },
  fetchSigTimQualidadeToken({ commit }: Action) {
    return api.get(tokenSigtimQualidade).then(({ data }) => {
      commit('SET_TOKEN', data.data.token);
      commit('SET_REPORTID', data.data.reportId);
    });
  },
  fetchSigTimCapilaridadeToken({ commit }: Action) {
    return api.get(tokenSigtimCapilaridade).then(({ data }) => {
      commit('SET_TOKEN', data.data.token);
      commit('SET_REPORTID', data.data.reportId);
    });
  },
  fetchSigTimInvasoesPenalidadesToken({ commit }: Action) {
    return api.get(tokenSigtimInvasoesPenalidades).then(({ data }) => {
      commit('SET_TOKEN', data.data.token);
      commit('SET_REPORTID', data.data.reportId);
    });
  },
  fetchSigTimPenetracaoChipToken({ commit }: Action) {
    return api.get(tokenSigtimPenetracaoChip).then(({ data }) => {
      commit('SET_TOKEN', data.data.token);
      commit('SET_REPORTID', data.data.reportId);
    });
  },
  fetchSigTimMeuPainel({ commit }: Action) {
    return api.get(tokenSigtimMeuPainel).then(({ data }) => {
      commit('SET_TOKEN', data.data.token);
      commit('SET_REPORTID', data.data.reportId);
    });
  },
  fetchSigTimPaliativo({ commit }: Action) {
    return api.get(tokenSigtimPaliativo).then(({ data }) => {
      commit('SET_TOKEN', data.data.token);
      commit('SET_REPORTID', data.data.reportId);
    });
  },
  fetchSigTimDrillDownChip({ commit }: Action) {
    return api.get(tokenSigtimDrillDownChip).then(({ data }) => {
      commit('SET_TOKEN', data.data.token);
      commit('SET_REPORTID', data.data.reportId);
    });
  },
  fetchSigTimRastreabilidadeApis({ commit }: Action) {
    return api.get(tokenSigtimRastreabilidadeApis).then(({ data }) => {
      commit('SET_TOKEN', data.data.token);
      commit('SET_REPORTID', data.data.reportId);
    });
  },
  fetchVisitToken({ commit }: Action) {
    return api.get(tokenVisitEndpoint).then(({ data }) => {
      commit('SET_TOKEN', data.data.token);
      commit('SET_REPORTID', data.data.reportId);
    });
  },
  fetchCheckListToken({ commit }: Action) {
    return api.get(tokenVisitCheckList).then(({ data }) => {
      commit('SET_TOKEN', data.data.token);
      commit('SET_REPORTID', data.data.reportId);
    });
  },
  fetchPlanosAcaotToken({ commit }: Action) {
    return api.get(tokenPlanosAcao).then(({ data }) => {
      commit('SET_TOKEN', data.data.token);
      commit('SET_REPORTID', data.data.reportId);
    });
  },
  fetchPtokenPainelGerencialToken({ commit }: Action) {
    return api.get(tokenPainelGerencial).then(({ data }) => {
      commit('SET_TOKEN', data.data.token);
      commit('SET_REPORTID', data.data.reportId);
    });
  },
  fetchHDCIntegracaoToken({ commit }: Action) {
    return api.get(tokenHDCIntegracao).then(({ data }) => {
      commit('SET_TOKEN', data.data.token);
      commit('SET_REPORTID', data.data.reportId);
    });
  },

  fetchAccessRequestsToken({ commit }: Action) {
    return api.get(tokenAccessRequests).then(({ data }) => {
      commit('SET_TOKEN', data.data.token);
      commit('SET_REPORTID', data.data.reportId);
    });
  },
  fetchOperacaoAMSTIMToken({ commit }: Action) {
    return api.get(tokenOperacaoAMSTIM).then(({ data }) => {
      commit('SET_TOKEN', data.data.token);
      commit('SET_REPORTID', data.data.reportId);
    });
  },
  fetchLastAccessUser({ commit }: Action) {
    return api.get(tokenLastAccessUser).then(({ data }) => {
      commit('SET_TOKEN', data.data.token);
      commit('SET_REPORTID', data.data.reportId);
    });
  },
  fetchAccessControlDepartmentalSystems({ commit }: Action) {
    return api.get(tokenAccessControlDepartmentalSystems).then(({ data }) => {
      commit('SET_TOKEN', data.data.token);
      commit('SET_REPORTID', data.data.reportId);
    });
  },
  fetchHomeBroker({ commit }: Action) {
    return api.get(tokenHomeBroker).then(({ data }) => {
      commit('SET_TOKEN', data.data.token);
      commit('SET_REPORTID', data.data.reportId);
    });
  },
  fetchImportManagement({ commit }: Action) {
    return api.get(tokenSigtimImportManagement).then(({ data }) => {
      commit('SET_TOKEN', data.data.token);
      commit('SET_REPORTID', data.data.reportId);
    });
  },
  fetchTimClosing({ commit }: Action) {
    return api.get(tokenTimClosing).then(({ data }) => {
      commit('SET_TOKEN', data.data.token);
      commit('SET_REPORTID', data.data.reportId);
    });
  },
  fetchPdvCapillarity({ commit }: Action) {
    return api.get(tokenCapillarity).then(({ data }) => {
      commit('SET_TOKEN', data.data.token);
      commit('SET_REPORTID', data.data.reportId);
    });
  },
  fetchPdvFinancial({ commit }: Action) {
    return api.get(tokenFinancial).then(({ data }) => {
      commit('SET_TOKEN', data.data.token);
      commit('SET_REPORTID', data.data.reportId);
    });
  },
};

export default {
  namespaced: true,
  state,
  getters,
  mutations,
  actions
};
